import { AdminBookingPhase, AdminBookingQuery } from '../api/client';

export const bookingPhases: AdminBookingPhase[] = ['WAITING_ACCEPTANCE', 'WAITING_START', 'WAITING_PICKUP', 'WAITING_DROPOFF', 'REVIEW_REQUIRED', 'COMPLETED', 'REJECTED', 'CANCELLED', 'EXPIRED'];
const dayFormatter = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Vienna', year: 'numeric', month: '2-digit', day: '2-digit' });
export function viennaDay(date: Date): string {
  const parts = dayFormatter.formatToParts(date);
  const value = (type: string) => parts.find(p => p.type === type)!.value;
  return `${value('year')}-${value('month')}-${value('day')}`;
}
function calendarDate(day: string): Date {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) throw new Error('Invalid calendar day');
  const date = new Date(`${day}T00:00:00Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== day) throw new Error('Invalid calendar day');
  return date;
}
export function shiftCalendarDay(day: string, days: number): string {
  const date = calendarDate(day); date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}
export function viennaMidnight(day: string): string {
  const target = calendarDate(day).getTime();
  const formatter = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Vienna', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  let instant = target;
  for (let i = 0; i < 4; i++) {
    const parts = formatter.formatToParts(new Date(instant));
    const value = (type: string) => Number(parts.find(p => p.type === type)!.value);
    const observed = Date.UTC(value('year'), value('month') - 1, value('day'), value('hour'), value('minute'), value('second'));
    if (observed === target) return new Date(instant).toISOString();
    instant += target - observed;
  }
  throw new Error('Unable to resolve Vienna midnight');
}
export function bookingQuery(search: URLSearchParams, now: Date): AdminBookingQuery {
  const rawPage = Number(search.get('page') || 0), rawSize = Number(search.get('size') || 20);
  const query: AdminBookingQuery = { page: Number.isInteger(rawPage) && rawPage >= 0 ? Math.min(rawPage, 1000000) : 0,
    size: Number.isInteger(rawSize) && rawSize > 0 ? Math.min(rawSize, 100) : 20 };
  const q = search.get('q')?.trim(); if (q) query.q = q;
  const phase = search.get('phase') as AdminBookingPhase;
  if (bookingPhases.includes(phase)) query.phase = phase;
  const view = search.get('view');
  if (view === 'open') return { ...query, openOnly: true };
  if (view !== 'today' && view !== 'range') return query;
  let start = viennaDay(now), end = start;
  if (view === 'range') {
    const rangeStart = search.get('start'), rangeEnd = search.get('end');
    try {
      if (rangeStart && rangeEnd) { calendarDate(rangeStart); calendarDate(rangeEnd); start = rangeStart; end = rangeEnd; }
    } catch { /* Malformed persisted dates normalize to today's selection. */ }
    if (start > end) throw new Error('Invalid range');
  }
  return { ...query, from: viennaMidnight(start), to: viennaMidnight(shiftCalendarDay(end, 1)) };
}
